import { orchestrator } from 'satcheljs';
import { onLoadMoreItems } from '../actions/internalActions';
import {
    getViewConfig,
    getScenarioListCacheId,
    shouldShowTasks,
} from '../selectors/agendaStoreSelectors';
import { getNumberOfDaysToLoad } from '../utils/getNumberOfDaysToLoad';
import { expandDateRange, getLoadedDateRange } from 'owa-calendar-events-loader';
import { getTodoCache } from '../store/todoCache';
import { TodoDescriptorType } from 'owa-todo-cache';
import { addDays } from 'owa-datetime';

export const onLoadMoreItemsOrchestrator = orchestrator(onLoadMoreItems, actionMessage => {
    const { scenarioId } = actionMessage;
    const listCacheId = getScenarioListCacheId(scenarioId);
    const loadedDateRange = getLoadedDateRange(listCacheId);
    const numberOfDaysToLoad = getNumberOfDaysToLoad(
        loadedDateRange,
        getViewConfig(scenarioId).maxDays
    );

    if (shouldShowTasks(scenarioId)) {
        getTodoCache(scenarioId).fetchTasks({
            type: TodoDescriptorType.DueDate,
            startDate: loadedDateRange.start,
            endDate: addDays(loadedDateRange.end, numberOfDaysToLoad),
        });
    }
    expandDateRange(numberOfDaysToLoad, listCacheId);
});
